<template>
  <span
    @click="$emit('click')"
    tabindex="0"
    role="button"
  >
    <RefreshCwIcon id="tooltip-restart" />
    <b-tooltip target="tooltip-restart" triggers="hover">
      重启游戏
    </b-tooltip>
  </span>
</template>

<script>
import { RefreshCwIcon } from "vue-feather-icons";
import { BTooltip } from "bootstrap-vue";

export default {
  name: "RestartControl",
  components: {
    RefreshCwIcon,
    BTooltip,
  },
};
</script>
